"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:!0}),exports.ButtonStyle=void 0;var _styledComponents=_interopRequireDefault(require("styled-components")),_global=require("../../constants/global.constants");const ButtonStyle=exports.ButtonStyle=_styledComponents.default.button`
    font-weight: 400;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  margin: 5px 10px 5px 0px;
  &.remove {
    background: none;
    color: ${_global.Themes[_global.Banner]};
    font-size: 16px;
    text-decoration: underline;
  }
  &.addCard {
    background: none;
    color: #7B1A27;
    font-size: 16px;
    text-decoration: underline;
    padding: 0px;
    margin-top: 24px;
  }
  &.cancel-btn {
    color: ${_global.Themes[_global.Banner]};
    background-color: transparent;
    font-size: 14px;
    text-decoration: underline;
    border: none;
    outline: none;
    margin-top: 0px;
  }
  &.cancel-btn:focus {
    border: 1.5px solid gray;
    outline-offset: 4px;
  }
  &.continue-btn {
    font-style: normal;
    font-size: 16px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    border: none;
    height: 40px;
    background: #7b1a27;
    border-radius: 100px;
    background-color: ${_global.Themes[_global.Banner]};
    color: #ffffff;
    width: ${a=>"FSAModal"==a?.modal?"200px":""};
  }
  &.remove-btn {
    font-style: normal;
    font-size: 16px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    border: none;
    height: 50px;
    background: #7b1a27;
    border-radius: 100px;
    background-color: ${_global.Themes[_global.Banner]};
    color: #ffffff;
    min-width: 204px;
  }
  &.freshpass-btn-web{
    font-style: normal;
    font-size: 16px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    border: none;
    height: 50px;
    background: #7b1a27;
    border-radius: 100px;
    background-color: ${_global.Themes[_global.Banner]};
    color: #ffffff;
    min-width: 456px;
  }
  &.confirm-btn {
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    border: none;
    min-width: 128px;
    height: 40px;
    width:90%;
    background: #7b1a27;
    border-radius: 100px;
    background-color: ${_global.Themes[_global.Banner]};
    color: #ffffff;
  }
  &.confirm-btn:disabled,  
  &.continue-btn:disabled,
  &.remove-btn:disabled,
  &.freshpass-btn-web:disabled {
    background-color: #f1f0ee !important;
    color: #7d7b78;
    cursor: default;
  }
  &.remove-btn-sns {
    font-style: normal;
    font-size: 16px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    border: none;
    height: 48px;
    background: #7b1a27;
    border-radius: 100px;
    background-color: ${_global.Themes[_global.Banner]};
    color: #ffffff;
    min-width: 296px;
  }
`;